import { Link } from "react-router-dom";
import Eyebrow from "@/components/base/Eyebrow";
import { footerColumns, riskDisclaimer } from "@/mocks/siteData";
import { brokerPartners } from "@/mocks/brokers";

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100 border-t-2 border-foreground-950">
      <div className="px-4 md:px-8">
        <div className="max-w-7xl mx-auto pt-14 md:pt-20 pb-10">
          <img
            src="/logo-w.png"
            alt="FX Order Types"
            width={180}
            className="h-auto w-[180px]"
          />
        </div>

        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-t-2 border-secondary-700 pt-10">
          <div className="lg:col-span-2">
            <Eyebrow tone="onDarkPrimary">About</Eyebrow>
            <p className="mt-4 text-sm leading-relaxed text-background-300 max-w-sm">
              A clear, visual reference for forex order types — how market, limit, stop and
              stop-limit orders really execute, and when to reach for each one.
            </p>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-label text-[11px] uppercase tracking-[0.2em] text-background-200 mb-4">
                [ {col.title} ]
              </h4>
              <ul className="flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="font-heading text-sm font-semibold text-background-200 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="max-w-7xl mx-auto border-t-2 border-secondary-700 py-8 flex flex-col gap-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <h4 className="font-label text-[11px] uppercase tracking-[0.2em] text-background-200">
              [ Partner offers ]
            </h4>
            <ul className="flex flex-wrap items-center gap-x-6 gap-y-2">
              {brokerPartners.map((broker) => (
                <li key={broker.name}>
                  <a
                    href={broker.url}
                    target="_blank"
                    rel="sponsored nofollow noopener noreferrer"
                    className="inline-flex items-center gap-1.5 font-heading text-sm font-semibold text-background-200 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {broker.name}
                    <i className="ri-arrow-right-up-line text-xs" aria-hidden="true"></i>
                    <span className="sr-only">(partner link, opens in a new tab)</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <p className="font-label text-[10px] leading-relaxed text-background-500 max-w-3xl">
            Partner links may earn this site a commission at no extra cost to you. Broker terms and
            regulation differ by country — verify details on the broker&apos;s site before funding.
          </p>
          <p className="font-label text-[11px] leading-relaxed text-background-400 max-w-3xl">
            {riskDisclaimer}
          </p>
          <p className="font-label text-[11px] uppercase tracking-[0.14em] text-background-400">
            © {new Date().getFullYear()} FX Order Types / Educational use only
          </p>
        </div>
      </div>
    </footer>
  );
}